import React from 'react';
import { Box, Pagination } from '@mui/material';

interface PaginationFnProps {
  count: number; // Total number of pages
  page: number; // Current page
  onPageChange: (event: React.ChangeEvent<unknown>, value: number) => void;
}

export default function PaginationFn({ count, page, onPageChange }: PaginationFnProps) {
  return (
    <>
      <Box
        justifyContent={'center'}
        alignItems="center"
        display={'flex'}
        sx={{ flexBasis: '100%' }}
      >
        <Pagination
          count={count}
          page={page}
          onChange={onPageChange}
          siblingCount={0}
          boundaryCount={0}
          showFirstButton={count > 1}
          showLastButton={count > 1}
          className="pagination"
        />
      </Box>
    </>
  );
}
